import React, { ComponentType } from 'react'
import { ValidateEmail } from '../ValidateEmail/ValidateEmail'
import { useHistory, useParams } from '../Router'
import { useAppSelector } from '../store/hooks'
import { requiresEmailValidation } from '../App/Util/customerRecognitionGates'
import { isAuthenticated } from '../cookies/session.cookies'

type Props = {
  component: ComponentType
}

export const CustomerStop: React.FC<Props> = ({ component: Component }) => {
  const history = useHistory()
  const { establishmentId } = useParams<{ [key: string]: string }>()
  const settings = useAppSelector((state) => state.settings)
  const { isAccessGranted } = settings

  const isPaymentStatus = history.location.pathname.includes('payment-status')
  const isSelectLocation = history.location.pathname.includes('select-location')
  const isAnnulationCondition = history.location.pathname.includes(
    'annulation-condition'
  )

  if (
    isAccessGranted === false &&
    settings.values &&
    requiresEmailValidation(settings.values) &&
    !isAuthenticated(establishmentId) &&
    !isAnnulationCondition &&
    !isPaymentStatus &&
    !isSelectLocation
  ) {
    return <ValidateEmail />
  }

  return <Component />
}
